import { DotnetServiceService } from "./shared/dotnet.service";
import { HollywoodServiceService } from "./shared/hollywood.service";
import { MusiclandServiceService } from "./shared/musicland.service";
import { NtvServiceService } from "./shared/ntv.service";

// export {NtvServiceService as UnlServiceService}
// export {MusiclandServiceService as UnlServiceService}
// export {DotnetServiceService as UnlServiceService}
export {HollywoodServiceService as UnlServiceService}
